/**
 * "English / Español" — two words, in the corner.
 *
 * THIS IS THE CONTROL THAT BREAKS THE CHICKEN-AND-EGG. Every other rung of the chain is unreachable
 * to the person who needs it most: the account preference needs a login, and reaching a settings
 * screen means reading the screens on the way to it. This one is reachable by somebody who cannot
 * read the page it sits on, because the only thing they have to recognise is the word "Español".
 *
 * NO FLAGS AND NO CODES, and both halves are load-bearing rather than fussy. A flag is a country: a
 * Mexican hand and a Salvadoran hand share no flag but share this language, so a flag asks them to
 * pick somebody else's. `ES` is not a word to anybody who does not already know what it stands for,
 * which is the same population this control exists for. So: the language's name, in its own
 * language, spelled out. (The rule is written down at length in modules/forms/i18n.js, which learned
 * it first.)
 *
 * Buttons rather than a <select>: a native select on a phone is a full-screen modal that reads in the
 * language you are trying to leave, and two options do not need a menu.
 */
import React from 'react'

import { languageName } from './languages'
import { useLanguage } from './LanguageContext.jsx'

export default function LanguageToggle({ onChoose, className = '', style = {} }) {
  const { lang, offered, setLanguage } = useLanguage()
  if (!offered || offered.length < 2) return null

  return (
    <div
      className={className}
      style={{ display: 'inline-flex', gap: 4, alignItems: 'center', ...style }}
    >
      {offered.map((tag, i) => {
        const active = tag === lang
        return (
          <React.Fragment key={tag}>
            {i > 0 && <span aria-hidden="true" style={{ opacity: 0.5 }}>/</span>}
            <button
              type="button"
              // aria-pressed rather than a visual-only highlight: which language you are in is
              // information, and a screen reader user gets it only if it is stated.
              aria-pressed={active}
              onClick={() => {
                setLanguage(tag, { persist: onChoose })
              }}
              style={{
                background: 'none',
                border: 0,
                padding: '4px 6px',
                minHeight: 32,
                cursor: 'pointer',
                font: 'inherit',
                fontWeight: active ? 700 : 400,
                textDecoration: active ? 'underline' : 'none',
                opacity: active ? 1 : 0.8,
                color: 'inherit',
              }}
            >
              {languageName(tag)}
            </button>
          </React.Fragment>
        )
      })}
    </div>
  )
}
